export default "/_next/static/images/448fcd3918a8fcfebab64ac10c184e8d.png";